<template>
  <!--    公共警告框-->
  <el-dialog :title="title" :visible.sync="uploadDia" width="920px" :modal-append-to-body="false" :close-on-click-modal="false" :destroy-on-close="true" @close="cancelConfirm">
    <!-- 内容 -->
    <el-steps v-if="uploadType!='look'" :active="uploadActive" finish-status="success">
      <el-step :title="uploadType=='edit'?'更新设置':'选择数据'" />
      <el-step :title="uploadType=='edit'?'更新完成':'设置表信息'" />
      <el-step v-if="uploadType!='edit'" title="创建完成" />
    </el-steps>

    <div v-if="uploadType=='edit'">
      <h3>更新设置</h3>
      <el-form ref="uploadEditRef" :model="uploadForm" label-width="110px" :rules="uploadRules" class="upload-form">
        <el-form-item label="更新方式" prop="updateType">
          <el-radio-group v-model="uploadForm.updateType">
            <el-radio v-for="(item,index) in updateTypeOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传数据" prop="fileList">
          <el-button v-if="uploadForm.fileList.length==0" size="small" type="primary" @click="uploadFile">点击上传</el-button>
          <div v-else>
            <span>{{ uploadForm.fileList[0].name }}</span>
            <i class="el-icon-delete" style="margin-left: 10px;cursor: pointer;font-size: 15px" @click="delFile" />
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div v-if="uploadActive==1||uploadType=='look'">
      <template v-if="uploadType!='edit'">
        <h3>基础信息</h3>
        <el-form ref="uploadFirstRef" :model="uploadForm" label-width="110px" :rules="uploadRules" class="upload-form">
          <div style="display: flex">
            <el-form-item label="数据源类型" prop="datasourceMd5Id">
              <el-select v-model="uploadForm.datasourceMd5Id" placeholder="请选择" :disabled="uploadType=='look'">
                <el-option v-for="(item,index) in datasourceMd5IdOptions" :label="item.name" :value="item.md5Id" />
              </el-select>
            </el-form-item>
            <el-form-item label="数据库名称" prop="dataBaseId">
              <el-select v-model="uploadForm.dataBaseId" placeholder="请选择" :disabled="true">
                <el-option v-for="(item,index) in dataBaseIdOptions" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="元数据标签" prop="labelMd5Ids">
              <el-cascader v-model="uploadForm.labelMd5Ids" :show-all-levels="false" :options="labelMd5IdsOptions" :props="{value:'md5Id',label:'labelName',multiple:true,checkStrictly: true}" placeholder="请选择" />
            </el-form-item>
          </div>
          <el-form-item v-if="uploadType!='look'" label="上传数据" prop="fileList">
            <el-button v-if="uploadForm.fileList.length==0" size="small" type="primary" @click="uploadFile">点击上传</el-button>
            <div v-else>
              <span>{{ uploadForm.fileList[0].name }}</span>
              <i class="el-icon-delete" style="margin-left: 10px;cursor: pointer;font-size: 15px" @click="delFile" />
            </div>
          </el-form-item>
        </el-form>
      </template>
      <template v-if="uploadType!='look'">
        <h3>结果预览</h3>
        <el-table :data="fileTableShow.tbody" :cell-style="cellStyle">
          <el-table-column v-for="(item,index) in fileTableShow.thead" :key="index" :prop="item.property">
            <template slot="header">
              <span v-if="item.color" :style="{color:item.color}">{{ item.name }}</span>
              <span v-else>{{ item.name }}</span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row[item.property] || '' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>

    <div v-if="(uploadActive==2||uploadType=='look')&&uploadType!='edit'">
      <h3>表设置</h3>
      <el-form ref="uploadSecondRef" :model="uploadForm" label-width="110px" :rules="uploadRules" class="upload-second-form">
        <el-form-item label="表名" prop="tableName">
          <el-select value="tmp" disabled class="tableName-select" />
          <el-input v-model="uploadForm.tableName" placeholder="请输入英文小写" class="tableName-input" :disabled="uploadType=='look'" />
        </el-form-item>
        <el-form-item label="有效期" prop="effectiveType">
          <el-radio-group v-model="uploadForm.effectiveType">
            <el-radio :label="1">永久</el-radio>
            <el-radio :label="2">自定义</el-radio>
          </el-radio-group>
          <el-date-picker v-if="uploadForm.effectiveType==2" v-model="uploadForm.effectiveTime" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm:ss" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" align="right" size="small" class="valid-date" />
        </el-form-item>
        <el-form-item label="表结构信息">
          <el-table :data="fileBody">
            <el-table-column width="40">
              <template slot-scope="scope">
                <el-link :underline="false" @click="deleteColumn(scope)">
                  <i class="el-icon-delete" /></el-link>
              </template>
            </el-table-column>
            <el-table-column label="序号" type="index" width="50" />
            <el-table-column label="字段名" width="160">
              <template slot-scope="scope">
                <el-input v-model="scope.row.columnName" :disabled="uploadType=='look'" />
              </template>
            </el-table-column>
            <el-table-column label="字段类型" width="160">
              <template slot-scope="scope">
                <el-select v-model="scope.row.columnType" :disabled="uploadType=='look'" @change="columnTypeChange(scope.row)">
                  <el-option v-for="item in columnTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="格式化" width="160">
              <template slot-scope="scope">
                <el-select v-if="scope.row.columnType=='Number'" v-model="scope.row.columnLength" :disabled="uploadType=='look'">
                  <el-option v-for="item in columnLengthOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="160">
              <template slot-scope="scope">
                <el-input v-model="scope.row.columnDesc" :disabled="uploadType=='look'" />
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>

    <div v-else-if="uploadActive==3||(uploadType=='edit'&&uploadActive==2)">
      <div class="step_3">
        <span class="iconfont icon-chenggong" style="color: #24915a;font-size: 50px" />
        <div class="title">创建成功</div>
        <div class="content">
          <div class="table_name">
            <span>元数据表 : </span><span>{{ tableSuccess.tableName }}</span>
            <el-button v-clipboard:copy="tableSuccess.tableName" v-clipboard:success="clipboardSuccess" type="primary" size="mini" style="margin-left: 30px;">复制</el-button>
          </div>
          <div class="table_index">
            <span>元数据表字段 : </span><span class="index_item">{{ tableSuccess.tableColumns }}</span>
          </div>
          <div class="table_index">
            <span>共计导入 : </span><span class="index_item">{{ tableSuccess.insertCount }} 条数据</span>
          </div>
        </div>
      </div>
    </div>

    <el-dialog width="620px" title="上传文件" :visible.sync="uploadFileDia" append-to-body>
      <el-form ref="fileRef" :model="uploadForm" label-width="110px" :rules="uploadRules" class="file-form">
        <el-form-item label="文件分隔符" prop="split">
          <el-radio-group v-model="uploadForm.split">
            <el-radio label=",">默认逗号</el-radio>
            <el-radio :label="encodeURI('\t')">制表符 \t</el-radio>
            <el-radio label="custom">自定义</el-radio>
          </el-radio-group>
          <el-input v-if="uploadForm.split=='custom'" v-model="uploadForm.customSplit" class="split-input" />
        </el-form-item>
        <el-form-item label="上传文件" prop="fileList">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="uploadUrl()"
            accept=".txt,.csv,.xlsx,.xls"
            multiple
            :limit="1"
            :auto-upload="false"
            :with-credentials="false"
            :on-change="loadFile"
            :on-success="loadSuccess"
            :file-list="uploadForm.fileList"
          >
            <el-button slot="trigger" plain>上传文件</el-button>
            <el-popover placement="right" width="200" trigger="hover">
              <span style="font-size: 12px;color: #666">
                提示：支持txt、csv、xlsx、xls格式
              </span>
              <i slot="reference" class="el-icon-info item-icon" style="font-size: 18px;color:#3a89ff;margin-left: 10px;" />
            </el-popover>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" plain @click="cancelFileConfirm">取 消</el-button>
        <el-button type="primary" @click="handleUpload">上 传</el-button>
      </div>
    </el-dialog>

    <el-dialog width="620px" title="创建中" :visible.sync="createPro" append-to-body>
      <div style="display: flex;flex-direction: column;align-items: center;height: 80px">
        <span style="flex: 1;font-size: 20px">{{ uploadForm.tableName }}数据表正在创建中...</span>
        <span style="flex: 1">关闭本页不影响创建数据表操作</span>
      </div>
      <el-progress :stroke-width="26" :percentage="percentage" />
    </el-dialog>

    <div slot="footer">
      <el-button type="primary" plain @click="uploadDia = false">{{ (uploadActive==3)||(uploadType=='edit'&&uploadActive==2)?'关 闭':'取 消' }}</el-button>
      <template v-if="uploadActive==1">
        <el-button v-if="uploadType=='look'" type="primary" @click="lookToSave">保存</el-button>
        <el-button v-else-if="uploadType=='edit'" type="primary" @click="handleUpdate">开始更新</el-button>
        <el-button v-else type="primary" @click="nextUpload">下一步</el-button>
      </template>
      <template v-else-if="uploadActive==2&&uploadType!='edit'">
        <el-button type="primary" @click="backUpload">上一步</el-button>
        <el-button type="primary" @click="handleCreate">开始创建</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import clipboard from '@/directive/clipboard/index.js'
import { apiUrl } from '@Dcs~/api/env'

import { queryLabelBy, add_file, datasource_select, edit_file, queryBy_datas, look_file } from '@Dcs~/api/metadataList_model'

export default {
  name: 'LocalUpload',
  directives: { clipboard },
  props: {
    title: {
      type: String,
      default: '文件上传'
    }

  },
  data() {
    const checkSplit = (rule, value, callback) => {
      if (value == 'custom') {
        if (this.uploadForm.customSplit == '') {
          callback(new Error('请输入自定义分隔符'))
        }
      }
      callback()
    }
    const checkEffectiveType = (rule, value, callback) => {
      if (value == 2) {
        if (!this.uploadForm.effectiveTime) {
          callback(new Error('请选择自定义有效期'))
        }
      }
      callback()
    }
    return {
      percentage: 0,
      createPro: false,
      uploadDia: false,
      uploadFileDia: false,
      fileList: [],
      uploadActive: 1,
      fileTableShow: {
        thead: [],
        tbody: []
      },
      // 弹窗类型 新增还是查看还是编辑
      uploadType: '',
      uploadForm: {
        // 编辑的时候的id
        tableMd5Id: '',
        datasourceMd5Id: '',
        dataBaseId: 'bdc_tmp',
        labelMd5Ids: [],
        // 分隔符
        split: ',',
        // 自定义输入分隔符
        customSplit: '',
        // 上传的文件
        fileList: [],
        tableName: '',
        // 有效期
        effectiveType: 1,
        // 自定义有效期
        effectiveTime: '',
        // 表结构
        columns: [],
        // 导入接口返回的url
        fileUrl: '',
        // 更新方式
        updateType: 1
      },
      // 文件上传路径
      actionUrl: '',
      // 文件数据展示
      fileBody: [],
      // 最终展示的元数据表和元数据字段
      tableSuccess: {
        tableName: '',
        tableColumns: '',
        insertCount: 0
      },
      labelMd5IdsOptions: [],
      datasourceMd5IdOptions: [],
      dataBaseIdOptions: [{ label: 'bdc_tmp', value: 'bdc_tmp' }],
      updateTypeOptions: [{ label: '覆盖更新', value: 1 }, { label: '追加更新', value: 2 }],
      uploadRules: {
        datasourceMd5Id: [{ required: true, message: '请选择数据源类型', trigger: 'change' }],
        dataBaseId: [{ required: true, message: '请选择数据库名称', trigger: 'change' }],
        split: [{ required: true, validator: checkSplit, trigger: 'change' }],
        fileList: [{ required: true, message: '请选择文件并上传', trigger: 'change' }],
        tableName: [{ required: true, message: '请输入表名', trigger: 'change' }],
        effectiveType: [{ required: true, validator: checkEffectiveType, trigger: 'change' }]
      },
      columnTypeOptions: [{ label: 'String', value: 'String' }, { label: 'Number', value: 'Number' }],
      columnLengthOptions: [{ label: '2位', value: 2 }, { label: '3位', value: 3 }, { label: '4位', value: 4 }, { label: '5位', value: 5 }],
      pickerOptions: {
        disabledDate(time) {
          // 即大于开始时间小于结束时间
          return time.getTime() < Date.now()
        }
      }
    }
  },

  methods: {
    // 删除某行
    deleteColumn(scope) {
      this.fileBody.splice(scope.$index, 1)
    },
    // 字段类型变化
    columnTypeChange(row) {
      if (row.columnType == 'Number') {
        row.columnLength = 2
      }
    },
    // 上传文件
    addFile() {
      this.getSelect()
      this.uploadType = 'add'
      this.uploadDia = true
    },
    // 查看文件
    lookFile(id, md5Id) {
      this.getSelect()
      this.uploadForm.tableMd5Id = md5Id

      queryBy_datas(id).then((res) => {
        if (res.code == 1) {
          this.uploadForm.datasourceMd5Id = res.data.metaTable.dataSourceName
          this.uploadForm.dataBaseId = res.data.metaTable.dataBaseName
          this.uploadForm.labelMd5Ids = res.data.metaTable.metaLabels
          this.uploadForm.tableName = res.data.metaTable.tableName
          this.uploadForm.effectiveType = res.data.effectiveType
          this.uploadForm.effectiveTime = res.data.effectiveTime

          this.uploadForm.columns = res.data.metaColumns

          console.log(this.uploadForm)
          this.fileBody = []
          this.uploadForm.columns.forEach(item => {
            if (item.columnType == 'Number') {
              this.fileBody.push({ columnName: item.columnName, columnType: item.columnType, columnLength: item.columnLength ? parseInt(item.columnLength) : 2 })
            } else {
              this.fileBody.push({ columnName: item.columnName, columnType: item.columnType })
            }
          })
        }
      })

      this.uploadType = 'look'
      this.uploadDia = true
    },
    // 更新数据
    editFile(id) {
      this.getSelect()
      this.uploadForm.tableMd5Id = id
      this.uploadType = 'edit'
      this.uploadDia = true
    },
    // 获取下拉
    getSelect() {
      // 标签接口请求
      queryLabelBy().then((res) => {
        if (res.code == 1) {
          this.labelMd5IdsOptions = res.data
        }
      })
      // 数据源下拉
      datasource_select().then((res) => {
        if (res.code == 1) {
          this.datasourceMd5IdOptions = res.data
        }
      })
    },
    // 上传文件
    uploadFile() {
      this.uploadFileDia = true
    },
    // 设置上传url
    uploadUrl() {
      if (this.uploadForm.split != 'custom') {
        this.actionUrl = apiUrl.gateUrl + '/table/' + (this.uploadForm.tableMd5Id ? 'updateByReadCsv' : 'readCsv') + '?splitor=' + this.uploadForm.split + '&tableMd5Id=' + this.uploadForm.tableMd5Id
      } else {
        this.actionUrl = apiUrl.gateUrl + '/table/' + (this.uploadForm.tableMd5Id ? 'updateByReadCsv' : 'readCsv') + '?splitor=' + this.uploadForm.customSplit + '&tableMd5Id=' + this.uploadForm.tableMd5Id
      }
      return this.actionUrl
    },
    // 确定上传
    handleUpload() {
      this.$refs.fileRef.validate(valid => {
        if (valid) {
          // 文件上传之前 校验文件类型
          // if(!['text/plain','application/vnd.ms-excel'].includes(this.uploadForm.fileList[0].raw.type)){
          //     this.$message({type:'error',message:'请重新选择txt或csv文件'})
          //     return false
          // }
          this.$refs.upload.submit()
        }
      })
    },
    // 取消上传弹窗
    cancelFileConfirm() {
      this.uploadFileDia = false
      this.$refs.fileRef.resetFields()
    },
    // 删除已选择的文件
    delFile() {
      this.$confirm(`是否确认删除“${this.uploadForm.fileList[0].name}”数据？该操作不可恢复`, '删除上传数据', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.uploadForm.fileList = []
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    // 加载文件内容
    loadFile(file, fileList) {
      this.uploadForm.fileList = fileList
    },
    // 文件上传成功
    loadSuccess(res) {
      if (res.code == 1) {
        this.uploadFileDia = false
        this.uploadForm.fileUrl = res.data.fileUrl
        const header = res.data.headers
        let body = res.data.bodies

        const headerLen = header.length
        body = body.map((item, index) => {
          const obj = {}
          item.forEach((chlItem, chlIndex) => {
            obj[header[chlIndex].property] = chlItem
          })
          return obj
        })
        this.fileTableShow.thead = header
        this.fileTableShow.tbody = body
      } else {
        this.$message({ type: 'error', message: res.msg })
        this.$refs.upload.clearFiles()
      }
    },
    // 下一步
    nextUpload() {
      this.$refs.uploadFirstRef.validate(valid => {
        if (valid) {
          this.fileBody = []
          this.fileTableShow.thead.forEach(item => {
            this.fileBody.push({ columnName: item.columnName, columnType: item.columnType, columnLength: 2, columnDesc: '' })
          })
          this.uploadActive++
        }
      })
    },
    // 上一步
    backUpload() {
      this.uploadActive--
    },
    // 开始创建
    handleCreate() {
      this.$refs.uploadSecondRef.validate(valid => {
        if (valid) {
          const param = this.getParam()
          console.log(param)
          console.log(JSON.stringify(param))
          this.percentage = 0
          this.createPro = true
          const setPercent = setInterval(() => {
            if (this.percentage < 90) {
              this.percentage += Math.ceil(Math.random() * 10)
            }
          }, 500)
          add_file(param).then(res => {
            if (res.code == 1) {
              this.$emit('getList')
              this.percentage = 100
              this.tableSuccess.tableName = res.data.tableName
              this.tableSuccess.tableColumns = res.data.columns
              this.tableSuccess.insertCount = res.data.insertCount
              this.uploadActive++
            }
            clearInterval(setPercent)
            this.createPro = false
          })
        }
      })
    },
    // 复制回调
    clipboardSuccess() {
      this.$message({
        message: '复制成功',
        type: 'success',
        offset: 70,
        duration: 1500
      })
    },
    // 开始更新
    handleUpdate() {
      this.$refs.uploadEditRef.validate(valid => {
        if (valid) {
          const param = this.getParam()
          edit_file(param).then(res => {
            if (res.code == 1) {
              this.tableSuccess.tableName = res.data.tableName
              this.tableSuccess.tableColumns = res.data.columns
              this.tableSuccess.insertCount = res.data.insertCount
              this.uploadActive++
              this.$emit('getList')
            }
          })
        }
      })
    },

    // 取消
    cancelConfirm() {
      this.uploadDia = false
      // this.$data = this.$options.data()
      // console.log(this.$options.data.call(this))
      Object.assign(this.$data, this.$options.data.call(this))
    },
    // 保存
    lookToSave() {
      this.$refs.uploadSecondRef.validate(valid => {
        if (valid) {
          const param = this.getParam()
          console.log(param)
          look_file(param).then(res => {
            if (res.code == 1) {
              this.$message({ type: 'success', message: '编辑成功' })
              this.uploadDia = false
              this.$emit('getList')
            }
          })
        }
      })
    },
    // 设置参数
    getParam() {
      const param = JSON.parse(JSON.stringify(this.uploadForm))
      this.fileBody.forEach(item => {
        if (item.columnType == 'Number') {
          param.columns.push({ columnName: item.columnName, columnType: item.columnType, columnLength: item.columnLength })
        } else {
          param.columns.push({ columnName: item.columnName, columnType: item.columnType })
        }
      })
      param.split == 'custom' ? param.splitor = param.customSplit : param.splitor = param.split

      // 更新数据操作
      if (param.tableMd5Id) {
        const columns = []
        const addColumns = []
        const notExistColumns = []
        this.fileTableShow.thead.forEach((item, index) => {
          if (item.color == 'black') {
            columns.push(item)
          } else if (item.color == 'green') {
            addColumns.push(item)
          } else {
            notExistColumns.push(item)
          }
        })
        param.columns = columns
        param.addColumns = addColumns
        param.notExistColumns = notExistColumns
      }

      return param
    },
    // 设置文件展示数据颜色
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (this.fileTableShow.thead.find(item => item.property == column.property).color) {
        return `color:${this.fileTableShow.thead.find(item => item.property == column.property).color}`
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
    .content{
        font-size: 15px;
        i{
            font-size: 20px;
            color: rgb(255,150,62);
        }
    }
    .upload-form{

    }
    .upload-second-form{
        ::v-deep.el-form-item__content{
            display: flex;
        }
        .tableName-select{
            width: 100px;
            ::v-deep .el-input__inner{
                border-radius: 4px 0px 0px 4px;
                border-right: none;
            }
        }
        .tableName-input{
            width:180px;
            ::v-deep.el-input__inner{
                border-radius: 0px 4px 4px 0px;
            }
        }
        .valid-date{
            width: 220px;
            margin-left: 15px;
        }
    }
    .file-form{

        .split-input{
            width: 100px;
            margin-left: 14px;
        }
    }
    .el-radio{
        line-height: 36px;
    }

    .step_3 {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px;
        font-size: 18px;

        .title {
            padding: 20px;
        }

        .table_name {
            padding: 10px;
        }

        .table_index {
            padding: 10px;

            .index_item {
                margin: 0 5px;
            }
        }
    }
</style>
